<p-dialog header="Header" [(visible)]="showExportDialog" [style]="{width: '450px', height: '300px'}" [modal]="true" (onHide)="onClose()">
    <ng-template pTemplate="header" class="bg-primary">
      <div class="m-2 text-white">Export data</div>
    </ng-template>
    <div class="m-3">
        <div class="fs-5 fw-bold mb-2">
          {{exportData?.exportFrom}} {{exportData?.exportId}}
        </div>
        <div class="row my-3">
          <label for="datatype" class="col-4">Select data type</label>
          <div class="col-8">
            <select #graphKeyToExport class="form-select" aria-label="Default select example">
                @for (item of availableGraphs; track item) {
                  <option [value]="item.key" [selected]="exportData?.selectedGraph?.key === item.key">{{item.label}}</option>
                }
            </select>
          </div>
        </div>
        <div class="row">
          <label for="dataformat" class="col-4">Select format</label>
          <div class="col-8">
            <select #exportDataFormat class="form-select" aria-label="Default select example">
                @for (item of exportDataFormats; track item) {
                    <option [value]="item">{{item}}</option>
                }
            </select>
          </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
      <div class="m-2 d-flex justify-content-end gap-2">
        <p-button styleClass="px-3 py-2 w-100" (click)="onClose()" label="Cancel"></p-button>
        <p-button styleClass="px-3 py-2 text-nowrap" (click)="onExportDataDialogButtonClicked()" label="Export data" pAutoFocus [autofocus]="true"></p-button>
      </div>
    </ng-template>
</p-dialog>  

